import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../../environments/environment";
import { FloorTenantCompany, FloorTenantCompanyDto } from "../../../models/provider-parking/floor-tenant-company.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { MapperFloorTenantCompanyService } from '../../../mappers/provider-parking/mapper-floor-tenant-company.service';

@Injectable({
    providedIn: 'root',
})
export class ApiFloorTenantCompanyService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperFloorTenantCompanyService
    ) { }

    getFloorTenantCompanies(): Observable<FloorTenantCompany[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<FloorTenantCompanyDto[]>(
            '/backoffice/GetFloorTenantCompany',
            'GET',
            this.baseUrl,
            {
                labelLog: 'GetFloorTenantCompany',
                token: token,
                headerOnly: false,
                isConsoleLog: true
            }
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapFromDto(dto)))
        );
    }

    createFloorTenantCompany(payload: FloorTenantCompany): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapper.mapToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateFloorTenantCompany',
            'POST',
            this.baseUrl,
            {
                labelLog: 'CreateFloorTenantCompany',
                token: token,
                headerOnly: false,
                isConsoleLog: true,
                body: dto
            }
        );
    }
}
